// core version + navigation, pagination modules:
import Swiper, { Autoplay, Navigation } from 'swiper';
// import Swiper and modules styles
import 'swiper/css/autoplay';	

function videoSlider() {
  const vidSlider = new Swiper('.js-video-slider', {
    modules: [Navigation, Autoplay],
    loop: false,
    draggable: true,
    allowTouchMove: true,
    autoplay: false,
    speed: 600,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 15,
    navigation: {
      nextEl: '.swiper-video-next',
      prevEl: '.swiper-video-prev',
    },
    breakpoints: {
      767: { 
          slidesPerView: 2,
          spaceBetween: 30
      },
    },
  });
}
videoSlider();

export default videoSlider;